import './input.css';

/**
 * Поле ввода. Стили — в `input.css` на токенах `--theme-*`; в JSX только класс,
 * как требует DESIGN.md §Общие правила. `className` от вызывающего добавляется
 * последним, чтобы точечные переопределения работали.
 */
const Input = ({ className = '', ...props }) => (
  <input className={`input ${className}`.trim()} {...props} />
);

export { Input };
